module.exports = __webpack_public_path__ + "img/refresh.5b998841.png";